import React, { useEffect, useState } from 'react';

function NewsletterArchive({ currLang }) {
    const [newsletters, setNewsletters] = useState([]);

    useEffect(() => {
        fetch('/api/newsletters')
            .then(res => res.json())
            .then(data => setNewsletters(data));
    }, []);

    return (
        <div className="newsletter-archive" style={{ padding: '2rem' }}>
            <h1>{currLang === "IS" ? "Gömul Fréttabréf" : "Newsletter Archive"}</h1>
            {newsletters.map(nl => (
                <div key={nl.id} className="newsletter">
                    <hr />
                    <small>{currLang === "IS" ? "Sent þann: " : "Sent on: "}{new Date(nl.sent_at).toLocaleDateString()}</small>
                    <h2>{nl.subject}</h2>
                    <div dangerouslySetInnerHTML={{ __html: nl.content }} />
                    <hr />
                </div>
            ))}
        </div>
    );
}

export default NewsletterArchive;